import { create } from "zustand";
import { FormattedEvent, SpielErgebnisResult } from "../../../types";

type ErgebnisCache = Record<string, SpielErgebnisResult | null>;

export interface ErgebnisState {
  cache: ErgebnisCache;
  getErgebnis: (event: FormattedEvent) => Promise<SpielErgebnisResult | null>;
  loadedOnce: Record<string, boolean>;
  hasLoadedOnce: (event: FormattedEvent) => boolean;
  markLoadedOnce: (event: FormattedEvent) => void;

}

const makeKey = (event: FormattedEvent) =>
  `${event.start}_${event.title}`;

export const useErgebnisStore = create<ErgebnisState>((set, get): ErgebnisState => ({
  cache: {},
  loadedOnce: {},

  hasLoadedOnce: (event) => {
    const key = `${event.start}_${event.title}`;
    return get().loadedOnce[key] === true;
  },

  markLoadedOnce: (event: FormattedEvent) =>
    set(state => ({
      loadedOnce: { ...state.loadedOnce, [makeKey(event)]: true }
    })),

  getErgebnis: async (event: FormattedEvent): Promise<SpielErgebnisResult | null> => {
    const key = makeKey(event);
    const existing = get().cache[key];
    // return existing ergebnis if it exists and not is live
    if (existing && existing.ergebnis && !existing.live) {
      return existing;
    }

    const res = await fetch("/.netlify/functions/get-ergebnis", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        hash_id: event.hash_id,
      }),
    });

    if (res.ok) {
      const json = await res.json() as SpielErgebnisResult;
      if (json) {
        set((state: any) => ({ cache: { ...state.cache, [key]: json } }));
        get().markLoadedOnce(event);
        return json;
      }
    } else {
      console.error(await res.json())
    }
    return null;
  },
}));
